<template>
  <div class="management-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button v-if="funcView.add_notice" type="primary" icon="el-icon-plus" @click="addBtn">{{ funcView.add_notice }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="!selectedRow || selectedRow.state != '0'" v-if="funcView.notice_send" type="primary" @click="releaseBtn(selectedRow.noticeId, selectedRow.title)">
            <i class="icon icon-fabu"></i>
            {{ funcView.notice_send }}
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.keyword" :placeholder="$t('base_notice.biao_ti_nei_rong')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
      <el-form :inline="true" label-position="top">
        <!-- 日期 -->
        <el-form-item :label="$t('base_notice.chuang_jian_shi_jian')">
          <custom-date-picker
            v-model="formSearch.gmtCreate"
            type="datetimerange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width:100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('base_notice.tui_song_jue_se')" prop="pushRange">
          <custom-select v-model="formSearch.pushRange" code="bas_org_type" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_notice.tui_song_fan_wei')" prop="pushRole">
          <custom-select v-model="formSearch.pushRole" url="roleMsgList" :props="{ label: 'roleName', value: 'roleId' }" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </el-form-item>

        <el-form-item :label="$t('base_notice.tui_song_qu_dao')" prop="pushChannel">
          <custom-select v-model="formSearch.pushChannel" code="bas_msg_push_template_type" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        v-if="funcView.notice_list"
        index
        type="radio"
        tableCode="notice"
        v-loading="isLoading"
        v-model="selectedRow"
        :data="noticeList"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        :slots="['isPop', 'title']"
      >
        <template slot="title" slot-scope="scope">
          <el-button @click="seeBtn(scope.row.noticeId)" v-if="funcView.notice_detail" size="mini" type="text">{{ scope.row.title }}</el-button>
          <span v-else>{{ scope.row.title }}</span>
        </template>
        <template slot="isPop" slot-scope="scope">
          {{ scope.row.isPop ? $t('Common.com_yes') : $t('Common.com_no') }}
        </template>
        <el-table-column :label="$t('Common.com_handle')" fixed="right" min-width="160">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editBtn(scope.row.noticeId)" v-if="scope.row.state == '0' && funcView.notice_edit">{{ funcView.notice_edit }}</el-button>
            <el-button type="text" size="mini" @click="deleteBtn(scope.row.noticeId, scope.row.title)" v-if="(scope.row.state == '0' || scope.row.state == '2') && funcView.notice_remove">
              {{ funcView.notice_remove }}
            </el-button>
            <el-button type="text" size="mini" @click="disableBtn(scope.row.noticeId, scope.row.title)" v-if="scope.row.state == '1' && funcView.notice_forbid">{{ funcView.notice_forbid }}</el-button>
            <el-button v-if="funcView.notice_preview" type="text" size="mini" @click="preSeeBtn(scope.row.noticeId, scope.row.title)">{{ funcView.notice_preview }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page" v-if="funcView.notice_list">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 新增 编辑-->
    <notice-item-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getNotice"></notice-item-dialog>

    <!-- 查看通知 -->
    <notice-see-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></notice-see-dialog>

    <!-- 预览 -->
    <notice-preSee-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false"></notice-preSee-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import noticeItemDialog from './children/notice_item_dialog.vue';
import noticeSeeDialog from './children/notice_see_dialog';
import noticePreSeeDialog from './children/notice_preSee_dialog';

export default {
  name: 'notice',
  mixins: [resetFormSearchMixins],
  components: {
    noticeItemDialog,
    noticeSeeDialog,
    noticePreSeeDialog,
  },
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        keyword: '',
        // signingStartDate: undefined, // 开始时间
        // signingEndDate: undefined, // 结束时间

        gmtCreate: [], // 发布时间
        pushRange: '',
        pushRole: '',
        pushChannel: ''
      },

      invoiceTime: [],

      totalRows: null,
      isLoading: false,
      noticeList: [],
      selectedRow: {},

      // 新增/编辑
      dialogVisible1: false,
      dialogModel1: {},
      // dialogData1: {},

      // 查看
      dialogVisible2: false,
      dialogModel2: {},
      // dialogData2: {},

      // 预览
      dialogVisible3: false,
      dialogModel3: {},
      // dialogData3: {},

      indexNotice: [],
      link: null
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getNotice();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getNoticeIndex();
  },
  methods: {
    getNotice: function () {
      // 是空不传
      this.formSearch.gmtCreate = this.formSearch.gmtCreate || undefined;

      this.isLoading = true;
      this.$getJSON(apis.noticePage, this.formSearch).then((res) => {
        this.isLoading = false;
        const recordsData = res.data.records;
        // 推送对象  消息推送方式 数组变字符串用于展示
        recordsData.forEach((i) => {
          const pushRoleNameString = i.pushRoleName.join(',');
          i.pushRoleName = pushRoleNameString;
          const pushChannelNameString = i.pushChannelName.join(',');
          i.pushChannelName = pushChannelNameString;
          const pushRangeNameString = i.pushRangeName.join(',');
          i.pushRangeName = pushRangeNameString;
        });
        this.noticeList = recordsData;

        this.totalRows = res.data.total;
      });
    },
    // clearFilter: function () {
    //   this.formSearch.pushRange = '';
    //   this.formSearch.pushRole = '';
    //   this.formSearch.pushChannel = '';
    //   this.publishTimer = null; // 发布时间
    //   this.getNotice();
    // },
    // 获取未读消息 (暂时放这里)
    getNoticeIndex: function () {
      this.$getJSON(apis.noticeNoticeIndex).then((res) => {
        this.indexNotice = res.data.filter(item => !!item.isPop);
        if (this.indexNotice.length > 0) {
          this.dialogVisible3 = true;
          this.dialogModel3.title = this.indexNotice[0].title;
          this.dialogModel3.type = 'popup';
          this.dialogModel3.id = this.indexNotice[0].noticeId;
        }
      });
    },
    // 新增
    addBtn: function (id = undefined) {
      const title = this.$t('base_notice.xin_zeng_tong_zhi');
      this.dialogVisible1 = true;
      this.dialogModel1.title = title;
      this.dialogModel1.type = 'add';
      this.dialogModel1.id = id;
    },
    // 编辑
    editBtn: function (id) {
      const title = this.$t('base_notice.bian_ji_tong_zhi');
      this.dialogVisible1 = true;
      this.dialogModel1.title = title;
      this.dialogModel1.type = 'edit';
      this.dialogModel1.id = id;
    },
    // 删除
    deleteBtn: function (id, title) {
      const tips = this.$t('base_notice.nqdyscxzdtzom', [title]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.noticeDelete}/${id}`).then(() => {
            // 更新
            this.getNotice();
          });
        })
        .catch(() => {});
    },
    // 发布
    releaseBtn: function (id, title) {
      const tips = this.$t('base_notice.nqdyfbxzdtzom', [title]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.noticePublish}/${id}`).then(() => {
            // 更新
            this.getNotice();
          });
        })
        .catch(() => {});
    },
    // 禁用
    disableBtn: function (id, title) {
      const tips = this.$t('base_notice.nqdyjyxzdtzom', [title]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.noticeDisable}/${id}`).then(() => {
            // 更新
            this.getNotice();
          });
        })
        .catch(() => {});
    },
    // 查看
    seeBtn: function (id) {
      const title = this.$t('base_notice.tong_zhi_xiang_qing');
      this.dialogVisible2 = true;
      this.dialogModel2.title = title;
      this.dialogModel2.type = 'see';
      this.dialogModel2.id = id;
    },
    // 预览
    preSeeBtn: function (id) {
      const title = this.$t('base_notice.yu_lan_tong_zhi');
      this.dialogVisible3 = true;
      this.dialogModel3.title = title;
      this.dialogModel3.type = 'preSee';
      this.dialogModel3.id = id;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getNotice();
    }
  }
};
</script>

<style lang="scss">
@import '../../../style/colors.scss';
</style>
